var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"form__error-message"},[_c('span',{staticClass:"icon"},[_c('icon-alert')],1),_vm._v(" Sorry... Something happened. :( Try again? ")]),_c('contact-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }